module.exports = "/_next/static/images/city-910ec4889dc9be94250cb855075be4d9.png.webp";